import { useEffect } from 'react'

export const useCRMStyles = ({ isUseAtTilda, formData, popup, containerEl, formId }) => {
    useEffect(() => {
        if (!isUseAtTilda || !formData || !containerEl || !formId) return

        // Маркер контейнера для изоляции стилей при нескольких формах на странице
        containerEl.dataset.erzId = formId
        const scopeSelector = `[data-erz-id="${formId}"]`
        const styleElementId = `crm-dynamic-styles-${formId}`

        // Маппинг полей formData на CSS-переменные
        const styleMapping = {
            // Кнопки
            'UF_STYLE_BTN_COLOR': '--form-btn-color',
            'UF_STYLE_BTN_HOVER': '--form-btn-hover-color',
            'UF_STYLE_BTN_TEXT_COLOR': '--form-btn-text-color',
            'UF_STYLE_BTN_TEXT_COLOR_HOVER': '--form-btn-text-color-hover',
            'UF_STYLE_BTN_BORDER_RADIUS': '--form-btn-border-radius',

            // Поля формы
            'UF_STYLE_FIELD_HEIGHT': '--form-field-height',
            'UF_STYLE_FIELD_HEIGHT_M': '--form-field-height-mob',
            'UF_STYLE_FIELD_LABEL_COLOR': '--field-label-color',
            'UF_STYLE_FIELD_LABEL_SIZE': '--field-label-size',
            'UF_STYLE_FIELD_LABEL_SIZE_M': '--field-label-size-mob',

            // Форма
            'UF_STYLE_FORM_BACKGROUND_COLOR': '--form-bg',
            'UF_STYLE_FORM_BORDER_RADIUS': '--form-border-radius',
            'UF_STYLE_FORM_BORDER_RADIUS_M': '--form-border-radius-mob',
            'UF_STYLE_FORM_DESCR_COLOR': '--form-descr-color',
            'UF_STYLE_FORM_DESCR_SIZE': '--form-descr-size',
            'UF_STYLE_FORM_DESCR_SIZE_M': '--form-descr-size-mob',
            'UF_STYLE_FORM_MARGIN_Y': '--form-mY',
            'UF_STYLE_FORM_MARGIN_Y_M': '--form-mY-mob',
            'UF_STYLE_FORM_PADDING_X': '--form-pX',
            'UF_STYLE_FORM_PADDING_X_M': '--form-pX-mob',
            'UF_STYLE_FORM_PADDING_Y': '--form-pY',
            'UF_STYLE_FORM_PADDING_Y_M': '--form-pY-mob',
            'UF_STYLE_FORM_TITLE_COLOR': '--form-title-color',
            'UF_STYLE_FORM_TITLE_SIZE': '--form-title-size',
            'UF_STYLE_FORM_TITLE_SIZE_M': '--form-title-size-mob',
            'UF_STYLE_FORM_WIDTH': '--form-max-width',
            'UF_STYLE_FORM_WIDTH_M': '--form-max-width-mob',
            'UF_STYLE_LINKS_COLOR': '--form-links-color',

            'UF_CRM_38_1765452007596': '--field-label-weight',
            'UF_CRM_38_1765453158044': '--main-form-titless',
            'UF_CRM_38_1765454201530': '--field-background-color',
            'UF_CRM_38_1765454212489': '--field-border-color',
            'UF_CRM_38_1765456356992': '--field-background-automatic-color',
            'UF_CRM_38_1765457386230': '--field-border-automatic-color',
            'UF_CRM_38_1765459393364': '--button-position',
            'UF_STYLE_FIELD_TEXT_COLOR': '--input-color',
        }

        // Нормализация значения ширины: добавляем px к голому числу, 0 → none
        const normalizeWidthValue = (value) => {
            if (value === '0' || value === 0) {
                return 'none'
            }
            const numValue = typeof value === 'string' ? value.trim() : String(value)
            // Если единиц измерения нет (px, em, rem, %, vw, vh и т.д.) — добавляем px
            if (/^\d+(\.\d+)?$/.test(numValue)) {
                return `${numValue}px`
            }
            return numValue
        }

        // Находим или создаём <style> для этого экземпляра формы.
        // Вставляем первым ребёнком в .erz-form-root, чтобы переопределить
        // статические стили из variables.scss, подключённые до контейнера в DOM.
        let styleElement = document.getElementById(styleElementId)
        if (!styleElement) {
            styleElement = document.createElement('style')
            styleElement.id = styleElementId
            if (containerEl.firstChild) {
                containerEl.insertBefore(styleElement, containerEl.firstChild)
            } else {
                containerEl.appendChild(styleElement)
            }
        } else if (styleElement.parentNode !== containerEl) {
            if (containerEl.firstChild) {
                containerEl.insertBefore(styleElement, containerEl.firstChild)
            } else {
                containerEl.appendChild(styleElement)
            }
        }

        // Собираем CSS-правила для переменных (кроме max-width)
        const rules = []
        const mobileVariableMap = new Map() // мобильные значения → базовые переменные для медиа-запроса
        let hasMaxWidth = false
        let hasMaxWidthMob = false
        let maxWidthValue = null
        let maxWidthMobValue = null

        // Соответствие мобильных переменных базовым (переопределяются в @media)
        const mobileToBaseMapping = {
            '--form-field-height-mob': '--form-field-height',
            '--field-label-size-mob': '--field-label-size',
            '--form-title-size-mob': '--form-title-size',
            '--form-descr-size-mob': '--form-descr-size',
            '--form-mY-mob': '--form-mY',
            '--form-pY-mob': '--form-pY',
            '--form-pX-mob': '--form-pX',
            '--form-border-radius-mob': '--form-border-radius',
        }

        // max-width задаётся инлайн на контейнере, с учётом десктоп/мобайл breakpoint
        const applyMaxWidth = () => {
            const isMobile = window.matchMedia('(max-width: 999px)').matches
            const valueToUse = isMobile && maxWidthMobValue ? maxWidthMobValue : maxWidthValue

            if (valueToUse) {
                const finalValue = normalizeWidthValue(valueToUse)
                containerEl.style.setProperty('--form-max-width', finalValue)
            }
        }

        Object.entries(styleMapping).forEach(([formDataKey, cssVariable]) => {
            const value = formData[formDataKey]

            // Пропускаем null, undefined и пустую строку
            if (value != null && value !== '') {
                // Ширина формы — инлайн на контейнере (нужен пересчёт при resize)
                if (cssVariable === '--form-max-width') {
                    maxWidthValue = value
                    const finalValue = normalizeWidthValue(value)
                    containerEl.style.setProperty(cssVariable, finalValue)

                    if (finalValue !== 'none') {
                        hasMaxWidth = true
                    }
                } else if (cssVariable === '--form-max-width-mob') {
                    maxWidthMobValue = value
                    const finalValue = normalizeWidthValue(value)
                    containerEl.style.setProperty(cssVariable, finalValue)

                    if (finalValue !== 'none') {
                        hasMaxWidthMob = true
                    }
                } else {
                    // Остальные переменные — в <style>, scoped на контейнер этого экземпляра.
                    // Переменные наследуются вниз, SCSS с var(--form-*) менять не нужно.
                    rules.push(`  ${cssVariable}: ${value};`)

                    // Мобильные значения сохраняем для переопределения базовых в медиа-запросе
                    if (mobileToBaseMapping[cssVariable]) {
                        const baseVariable = mobileToBaseMapping[cssVariable]
                        mobileVariableMap.set(baseVariable, value)
                    }
                }
            }
        })

        // Фикс позиционирования Tilda popup-контейнера с формой внутри
        let popupCss = null
        if (popup) {
            popupCss = `.t-popup_show .t-popup__container:has(.erz-form-root) {
                            transform: none !important;
                            -webkit-transform: none !important;
                            top: 40px;
                            transition: none;
                         }`
        }

        applyMaxWidth()

        // Переключаем max-width при смене breakpoint (999px)
        const mediaQuery = window.matchMedia('(max-width: 999px)')
        const handleMediaChange = () => {
            applyMaxWidth()
        }

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', handleMediaChange)
        } else {
            mediaQuery.addListener(handleMediaChange)
        }

        // Формируем CSS и записываем в <style> экземпляра.
        // Переменные scoped на [data-erz-id], а не на :root — каждая форма со своими CRM-стилями.
        const cssParts = []

        if (rules.length > 0) {
            cssParts.push(`${scopeSelector} {\n${rules.join('\n')}\n}`)
        }

        // Мобильные переопределения — в том же scope, breakpoint совпадает с variables.scss
        if (mobileVariableMap.size > 0) {
            const mobileOverrideRules = []
            mobileVariableMap.forEach((value, baseVariable) => {
                mobileOverrideRules.push(`  ${baseVariable}: ${value};`)
            })
            cssParts.push(`@media (max-width: 999px) {\n  ${scopeSelector} {\n${mobileOverrideRules.join('\n')}\n  }\n}`)
        }

        if (popupCss) {
            cssParts.push(popupCss)
        }

        if (cssParts.length > 0) {
            styleElement.textContent = cssParts.join('\n\n')
        }

        // Центрируем форму внутри этого экземпляра, если задана ширина
        if (hasMaxWidth || hasMaxWidthMob) {
            // requestAnimationFrame — ждём появления .main-form в DOM
            requestAnimationFrame(() => {
                const mainFormElement = containerEl.querySelector('.main-form')
                if (mainFormElement) {
                    mainFormElement.style.marginLeft = 'auto'
                    mainFormElement.style.marginRight = 'auto'
                }
            })
        }

        // Cleanup: удаляем style этого экземпляра, инлайн max-width и слушатель resize
        return () => {
            const styleEl = document.getElementById(styleElementId)
            if (styleEl) {
                styleEl.remove()
            }

            containerEl.style.removeProperty('--form-max-width')
            containerEl.style.removeProperty('--form-max-width-mob')

            if (mediaQuery.removeEventListener) {
                mediaQuery.removeEventListener('change', handleMediaChange)
            } else {
                mediaQuery.removeListener(handleMediaChange)
            }
        }
    }, [isUseAtTilda, formData, popup, containerEl, formId])

    // Отдельный эффект: шрифт Tilda (Google Fonts) → --ff-base на document.
    // Глобально, т.к. на странице обычно один шрифт; наследуется всеми формами.
    useEffect(() => {
        if (!isUseAtTilda || !formData) return

        const checkAndSetGoogleFont = () => {
            // Ищем ссылки на Google Fonts (/css2 или с параметром family)
            const googleFontsLinks = document.querySelectorAll('link[href*="fonts.googleapis.com/css2"], link[href*="fonts.googleapis.com"][href*="family"]')
            if (googleFontsLinks.length > 0) {
                const firstLink = googleFontsLinks[0]
                const href = firstLink.getAttribute('href')

                if (href) {
                    try {
                        const url = new URL(href)
                        const familyParam = url.searchParams.get('family')

                        if (familyParam) {
                            // Несколько шрифтов через | — берём первый
                            const firstFont = familyParam.split('|')[0]
                            // Убираем параметры веса (например, :wght@100..900)
                            const fontName = firstFont.split(':')[0]
                            const decodedFontName = decodeURIComponent(fontName.replace(/\+/g, ' '))

                            document.documentElement.style.setProperty(
                                '--ff-base',
                                `"${decodedFontName}", Arial, Helvetica, sans-serif`
                            )
                            return true
                        }
                    } catch (error) {
                        console.warn('Failed to parse Google Fonts URL:', error)
                    }
                }
            }
            return false
        }

        if (!checkAndSetGoogleFont()) {
            // Повторная проверка — шрифт может подгрузиться асинхронно
            const timeoutId = setTimeout(() => {
                checkAndSetGoogleFont()
            }, 100)

            return () => clearTimeout(timeoutId)
        }
    }, [isUseAtTilda, formData])
}
